import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getOrganizationAssignmentsProgressSummaryQuery,
  getCourseDetailsQuery,
  getStudentsPypElementRatingsQuery,
  getAcademicCriteriaSetsQuery,
  getCourseAcademicYearTermsQuery,
  getIBGradeAssignmentsQuery,
  getStudentPublishedReportDetailsQuery,
} from "./ProgressSummaryQuery";

export const getOrganizationAssignmentsProgressSummaryFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationAssignmentsProgressSummaryQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCourseDetailsFromCache = ({ id, courseGradeFilters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseDetailsQuery,
      variables: {
        id,
        courseGradeFilters,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", []);
  else return {};
};

export const getStudentsPypElementRatingsFromCache = ({
  studentIds,
  filtersForRecentMost,
  startDate,
  endDate,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentsPypElementRatingsQuery,
      variables: {
        studentIds,
        filtersForRecentMost,
        startDate,
        endDate,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return queryData;
  else return {};
};

export const getAcademicCriteriaSetsFromCache = ({
  organizationId,
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAcademicCriteriaSetsQuery,
      variables: {
        organizationId,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCourseAcademicYearTermsQueryFromCache = ({
  id,
  curriculumProgramIds,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseAcademicYearTermsQuery,
      variables: {
        id,
        curriculumProgramIds,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeOrganizationAssignmentsInCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getOrganizationAssignmentsProgressSummaryQuery,
      variables,
      data: { node: data },
    });
  } catch (e) {}
};

export const getIBGradeAssignmentsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getIBGradeAssignmentsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getStudentPublishedReportDetailsFromCache = ({ ids, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentPublishedReportDetailsQuery,
      variables: {
        ids,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "multiNode", []);
};
